var _path, _path2, _path3, _path4, _circle, _path5, _ellipse, _ellipse2, _ellipse3, _circle2, _circle3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 69,
    viewBox: "0 0 84 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1007 14.0679C16.1007 14.0679 13.4733 8.37119 16.9448 8.43852C20.4164 8.50584 19.971 14.8051 19.971 14.8051",
    fill: "#079F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1007 14.0679C16.1007 14.0679 13.4733 8.37119 16.9448 8.43852C20.4164 8.50584 19.971 14.8051 19.971 14.8051",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99162 22.1296C5.99162 22.1296 0.921514 18.9567 1.00092 22.4283C1.08033 25.8998 6.61999 25.8808 6.61999 25.8808",
    fill: "#079F9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99162 22.1296C5.99162 22.1296 0.921514 18.9567 1.00092 22.4283C1.08033 25.8998 6.61999 25.8808 6.61999 25.8808",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4609,
    cy: 30.0003,
    r: 17.2163,
    fill: "#079F9F",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9564 26.2995C26.1246 27.0815 24.8489 28.8199 22.5926 29.0253C21.5793 31.0658 19.0986 32.4503 19.1884 29.6761",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.1305,
    cy: 23.5215,
    rx: 1.22394,
    ry: 1.94035,
    transform: "rotate(-35.37 24.1305 23.5215)",
    fill: "#434343"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.65,
    cy: 28.8326,
    rx: 1.22394,
    ry: 1.94035,
    transform: "rotate(-35.37 16.65 28.8326)",
    fill: "#434343"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2242,
    cy: 16.7327,
    rx: 1.45181,
    ry: 2.18721,
    transform: "rotate(-70.4 26.2242 16.7327)",
    fill: "#079F9F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9556,
    cy: 34.0444,
    r: 24.0731,
    transform: "rotate(-45 49.9556 34.0444)",
    fill: "#F8A63F",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9556,
    cy: 34.0436,
    r: 20.3184,
    fill: "white",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9484 34.0444L56.9053 25.0228C61.1172 28.2669 62.5258 33.9927 60.2995 38.8205C58.0732 43.6483 52.804 46.2947 47.602 45.1977C42.4 44.1006 38.6482 39.5517 38.5611 34.236C38.474 28.9203 42.0748 24.251 47.2381 22.9841L49.9484 34.0444Z",
    fill: "#FCD97B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7051 17.7428L49.9552 34.0441L57.3092 24.2371",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3521 36.333C25.4641 35.8945 38.1264 32.6249 39.5109 34.7638C40.2273 35.8721 37.1303 36.0464 37.1303 36.0464C37.1303 36.0464 38.501 36.8284 37.2874 39.3661C36.2188 41.6016 27.7031 43.4781 25.105 43.4781",
    fill: "#079F9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3521 36.333C25.4641 35.8945 38.1264 32.6249 39.5109 34.7638C40.2273 35.8721 37.1303 36.0464 37.1303 36.0464C37.1303 36.0464 38.501 36.8284 37.2874 39.3661C36.2188 41.6016 27.7031 43.4781 25.105 43.4781",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2493 1.78352L60.1053 3.3764C61.4701 3.59698 62.3977 4.88221 62.1771 6.24704L61.725 9.04471L46.9248 6.65277L47.377 3.8551C47.4829 3.19939 47.8452 2.61267 48.3839 2.22414C48.9226 1.8356 49.5937 1.67709 50.2493 1.78352Z",
    fill: "#F8A63F",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4673 7.2664L51.8885 4.63899L51.4673 7.2664Z",
    fill: "#F8A63F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4673 7.2664L51.8885 4.63899",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.895 8.1384L57.318 5.51099L56.895 8.1384Z",
    fill: "#F8A63F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.895 8.13839L57.318 5.51099",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7886 13.6697L76.2747 5.16771L80.4748 9.69749L70.7886 13.6697Z",
    fill: "white",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8857 16.4771L81.9798 14.2312L81.8849 19.2892L72.8857 16.4771Z",
    fill: "white",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.b1ce04ec544725aad1a96f33826c8ac5.svg";
export { ForwardRef as ReactComponent };